import { Component, Inject, OnInit } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { UserIdleService } from 'angular-user-idle';
import { AppComponent } from '../../app.component';

@Component({
  selector: 'app-session-timeout-snack',
  templateUrl: './session-timeout-snack.component.html',
  styleUrls: ['./session-timeout-snack.component.css']
})
export class SessionTimeoutSnackComponent {

  constructor(public snackBarRef: MatSnackBarRef<SessionTimeoutSnackComponent>,
    private userIdle: UserIdleService) {
    setTimeout(() => this.timer(), 1000);
  }

  public leftTime = 60;

  reset() {
    this.snackBarRef.dismiss();
    this.userIdle.resetTimer();
  }

  timer() {
    if (this.leftTime > 0) {
      this.leftTime -= 1;
      setTimeout(() => this.timer(), 1000);
    }
  }
}
